import { CanActivateFn } from '@angular/router';
import { combineLatest, filter, firstValueFrom, map, take } from 'rxjs';

import { AuthService } from '@auth0/auth0-angular';
import { inject } from '@angular/core';
import { Browser } from '@capacitor/browser';
import { SessionService } from '../session.service';



export const sessionGuard: CanActivateFn = async (route, state) => {
  const sessionService = inject(SessionService);

  if (!sessionService.isInitialized()) {
    return await sessionService.initializeSession();
  }

  return true;
};
